export default function TermosDeUso(){
    return(
        <h1>TERMOS DE USO</h1>
    )
}